import { Expand } from 'lucide-react';
import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export default function CardExpandButton() {
  return (
    <span
      aria-hidden="true"
      className={cn(
        buttonVariants({ variant: 'default', size: 'icon' }),
        'pointer-events-none absolute top-4 right-4 z-40 flex size-9 shrink-0 items-center justify-center rounded-full bg-white/5 border border-white/20 backdrop-blur-sm transition-all duration-300 ease-in-out text-white group-hover:text-white group-hover:bg-[#BFB7A1] group-hover:border-[#BFB7A1] shadow-none',
      )}
    >
      <Expand className="size-4 shrink-0" />
    </span>
  );
}
